import moment from "moment-timezone";

import { DepreciableCategory } from "../../types";
import { SAVE_DATE_FORMAT } from "@/v1/constants";

export const DEPRECIABLE_CATEGORY_CODES = Object.values(
  DepreciableCategory
) as string[];
export const LATEST_POSSIBLE_PURCHASE_DATE = moment().format(SAVE_DATE_FORMAT);
export const CUSTOM_ASSET_CLASS = "Sonstige";
